(function(Promotions, $, undefined) {

  var bindUIActions = function() {

    var productVariants = {
      65: '8436277443',
      25: '8436320131',
      tag: '5689418691' 
    };
    
    if (queryParams.promo === 'dads') {
      CartJS.addItem(productVariants[25]) 
    }
  }

  Promotions.init = function() {
    bindUIActions();
  }

}(window.Promotions = window.Promotions || {}, jQuery));